import { FormControl, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import React from 'react'

export type SelectOptionInputProps<T> = {
  availableOptions: readonly { [label: string]: T }[]
  selected: T
  setSelected: (selected: T) => void
  disabled?: boolean
}

const getItemLabel = <T extends unknown>(item: { [label: string]: T }) => Object.keys(item)[0]
const getItemValue = <T extends unknown>(item: { [label: string]: T }) => item[Object.keys(item)[0]]

const SelectOptionInput = <T extends unknown>({
  availableOptions,
  selected,
  setSelected,
  disabled,
}: SelectOptionInputProps<T>) => (
  <FormControl
    variant="outlined"
    margin="normal"
    sx={{
      flexShrink: 0,
      width: 'fit-content',
    }}
  >
    <InputLabel id="dropdown-label">Select Action</InputLabel>
    <Select
      value={availableOptions.findIndex((item) => getItemValue(item) === selected)}
      disabled={disabled}
      label="Select Action"
      onChange={(event: SelectChangeEvent<number>) => {
        const newSelectedIndex = event.target.value as number
        setSelected(getItemValue(availableOptions[newSelectedIndex]))
      }}
    >
      {availableOptions.map((value, index) => (
        <MenuItem key={JSON.stringify(value)} value={index}>
          <ListItemText primary={getItemLabel(value)} />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export default SelectOptionInput
